// extracted by mini-css-extract-plugin
module.exports = {"menuLinksHeading":"prenav-menu-menuLinksHeading--d488d","menuLinksAnchors":"prenav-menu-menuLinksAnchors--713ff"};